import { API, handleApiError } from "./utils";

export const getUser = async (id) => {
  try {
    const { data } = await API.get(`/users/${id}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateUser = async (id, formData) => {
  try {
    const { data } = await API.put(`/users/${id}`, formData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getPublicUsers = async () => {
  try {
    const { data } = await API.get("/users/public-users");
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getPublicUsersWithMatchingSkills = async () => {
  try {
    const { data } = await API.get("/users/public-users-with-matching-skills");
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getPublicUser = async (id) => {
  try {
    const { data } = await API.get(`/users/public-users/${id}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const followUser = async (id) => {
  try {
    const { data } = await API.patch(`/users/${id}/follow`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const unfollowUser = async (id) => {
  try {
    const { data } = await API.patch(`/users/${id}/unfollow`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getFollowingUsers = async (limit = 25, skip = 0) => {
  try {
    const { data } = await API.get(`/users/following?limit=${limit}&skip=${skip}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const searchFollowingUsers = async (query) => {
  try {
    const { data } = await API.get(`/users/following/search?q=${encodeURIComponent(query)}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getFollowersUsers = async (limit = 25, skip = 0) => {
  try {
    const { data } = await API.get(`/users/followers?limit=${limit}&skip=${skip}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const searchFollowersUsers = async (query) => {
  try {
    const { data } = await API.get(`/users/followers/search?q=${encodeURIComponent(query)}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const removeFollower = async (userId) => {
  try {
    const { data } = await API.patch(`/users/${userId}/remove-follower`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const searchUsers = async (query, page = 1) => {
  try {
    const { data } = await API.get(`/users/search?q=${query}&page=${page}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getFileUploadSettings = async () => {
  try {
    const { data } = await API.get("/users/config/file-upload-settings");
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getMutualSkills = async (userId) => {
  try {
    const { data } = await API.get(`/users/${userId}/mutual-skills`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getMutualCommunities = async (userId) => {
  try {
    const { data } = await API.get(`/users/${userId}/mutual-communities`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getPrivacySettings = async () => {
  try {
    const { data } = await API.get("/users/privacy-settings");
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updatePrivacySettings = async (settings) => {
  try {
    const { data } = await API.put("/users/privacy-settings", settings);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const blockUser = async (userId) => {
  try {
    const { data } = await API.patch(`/users/${userId}/block`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const unblockUser = async (userId) => {
  try {
    const { data } = await API.patch(`/users/${userId}/unblock`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getBlockedUsers = async () => {
  try {
    const { data } = await API.get("/users/blocked-users");
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

// Profile View Request APIs
export const createProfileViewRequest = async (profileOwnerId) => {
  try {
    const { data } = await API.post(`/users/profile-view-request/${profileOwnerId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

// Follow Request APIs
export const createFollowRequest = async (userId) => {
  try {
    const { data } = await API.post(`/users/follow-request/${userId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getReceivedFollowRequests = async (status, limit = 25, skip = 0) => {
  try {
    const params = new URLSearchParams({ limit, skip });
    if (status) params.append('status', status);
    const { data } = await API.get(`/users/follow-request/received?${params}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getSentFollowRequests = async (status, limit = 25, skip = 0) => {
  try {
    const params = new URLSearchParams({ limit, skip });
    if (status) params.append('status', status);
    const { data } = await API.get(`/users/follow-request/sent?${params}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const acceptFollowRequest = async (requestId) => {
  try {
    const { data } = await API.patch(`/users/follow-request/${requestId}/accept`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const denyFollowRequest = async (requestId) => {
  try {
    const { data } = await API.patch(`/users/follow-request/${requestId}/deny`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const withdrawFollowRequest = async (requestId) => {
  try {
    const { data } = await API.delete(`/users/follow-request/${requestId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const withdrawProfileViewRequest = async (requestId) => {
  try {
    const { data } = await API.delete(`/users/profile-view-request/${requestId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

// Notification APIs
export const getNotifications = async (limit = 20, skip = 0) => {
  try {
    const params = new URLSearchParams({ limit, skip });
    const { data } = await API.get(`/notifications?${params}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const markNotificationAsRead = async (notificationId) => {
  try {
    const { data } = await API.patch(`/notifications/${notificationId}/read`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const markAllNotificationsAsRead = async () => {
  try {
    const { data } = await API.patch(`/notifications/read-all`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteNotification = async (notificationId) => {
  try {
    const { data } = await API.delete(`/notifications/${notificationId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getUnreadNotificationCount = async () => {
  try {
    const { data } = await API.get(`/notifications/count`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getReceivedProfileViewRequests = async (status, limit = 25, skip = 0) => {
  try {
    const params = new URLSearchParams({ limit, skip });
    if (status) params.append('status', status);
    const { data } = await API.get(`/users/profile-view-request/received?${params}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getSentProfileViewRequests = async (status, limit = 25, skip = 0) => {
  try {
    const params = new URLSearchParams({ limit, skip });
    if (status) params.append('status', status);
    const { data } = await API.get(`/users/profile-view-request/sent?${params}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const acceptProfileViewRequest = async (requestId, accessType = "unlimited", expiryValue = null, expiryUnit = null) => {
  try {
    const body = { accessType };
    if (accessType === "limited" && expiryValue && expiryUnit) {
      body.expiryValue = expiryValue;
      body.expiryUnit = expiryUnit;
    }
    const { data } = await API.patch(`/users/profile-view-request/${requestId}/accept`, body);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const denyProfileViewRequest = async (requestId) => {
  try {
    const { data } = await API.patch(`/users/profile-view-request/${requestId}/deny`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const revokeProfileViewRequest = async (requestId) => {
  try {
    const { data } = await API.patch(`/users/profile-view-request/${requestId}/revoke`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};